module.exports = __webpack_public_path__ + "13ebca41dd1869e3c6926fc43e274d4d.jpg";